import React from 'react'
import { getAllArticles } from '../../Helpers/ArticleHelpers'
import ArticleCard from './ArticleCard'
import { Container, Grid, Typography, FormControl, InputLabel, Select, MenuItem, withStyles } from '@material-ui/core'
import * as qs from 'qs'
import Loading from '../Loading/Loading'

const styles = theme => ({
    heading: {
        borderBottom: `1px solid #${theme.palette.text.textSecondary}`,
        marginBottom: theme.spacing(2)
    },
    pageTitle: {
        display: 'inline-block',
        fontWeight: 'bold'
    },
    filters: {
        display: 'inline-block',
        float: 'right',
        marginRight: theme.spacing(2)
    },
    select: {
        width: 100
    }
})

class ClientArticlesList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            articles: null,
            viewedArticles: null,
            tags: [],
            authors: [],
            currentTag: null,
            currentAuthor: null
        }
        this.getArticles()
    }

    componentDidMount = () => {
        const getParams = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
        if (getParams.author) {
            this.setState({ currentAuthor: getParams.author })
        }
        if (getParams.tag) {
            this.setState({ currentTag: getParams.tag })
        }
    }

    getArticles = async () => {
        const articles = await getAllArticles(null, null, true)
        this.setState({ articles }, this.getTagsAndAuthors(articles))
    }

    getTagsAndAuthors = (articles) => {
        let tags = []
        let authors = []
        articles.forEach(article => {
            tags = [...tags, ...article.tags]
            if (authors.filter(a => a.name === article.authorName).length === 0) {
                authors.push({name: article.authorName, id: article.author})
            }
        })
        tags = [...new Set(tags)]
        this.setState({ tags, authors })
    }

    handleTagChange = e => {
        this.setState({ currentTag: e.target.value })
    }

    handleAuthorChange = e => {
        this.setState({ currentAuthor: e.target.value })
    }

    viewedArticles = () => {
        if (this.state.articles) {
            let viewedArticles = this.state.articles
            if (this.state.currentTag) {
                viewedArticles = viewedArticles.filter(a => a.tags.includes(this.state.currentTag))
            }
            if (this.state.currentAuthor) {
                console.log(this.state.currentAuthor)
                viewedArticles = viewedArticles.filter(a => a.authorName === this.state.currentAuthor)
            }
            return viewedArticles
        }
    }

    render() {
        const { classes } = this.props
        const articles = this.viewedArticles()
        return (
            <Container>
                {this.state.articles
                ?   
                    <div>
                        <div className={classes.heading}>
                            <Typography variant="h2" className={classes.pageTitle}>Articles</Typography>
                            <div className={classes.filters}>
                                <FormControl className={classes.select}>
                                    <InputLabel id="tag-filter-label">Tag</InputLabel>
                                    <Select 
                                        labelId="tag-filter-label"
                                        value={this.state.currentTag}
                                        onChange={this.handleTagChange}>
                                            <MenuItem value=''><br /></MenuItem>
                                            {this.state.tags.map(t => (
                                                <MenuItem key={t} value={t}>{t}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                                <FormControl className={classes.select}>
                                    <InputLabel id="author-filter-label">Author</InputLabel>
                                    <Select 
                                        labelId="author-filter-label"
                                        value={this.state.currentAuthor} 
                                        onChange={this.handleAuthorChange}>
                                            <MenuItem value=''><br /></MenuItem>
                                            {this.state.authors.map(a => (
                                                <MenuItem key={a.name} value={a.name}>{a.name}</MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <Grid container spacing={4}>
                            {articles.map(article => (
                                <Grid key={article.id} item md={4} sm={6} xs={12}>
                                    <ArticleCard article={article} />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                : 
                    <Loading />}
            </Container>
        )
    }
}

export default withStyles(styles)(ClientArticlesList)